/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { DatePicker, If } from '@cleartax/zoids';
import Barchart from './barChart/barChart';
import MISSummaryCard from './cards/misSummaryCard';
import {
  DateRange,
  MisToolBar,
  MisBarChart,
  DateRangeText,
  Mis,
  MisHeaders,
  MisHeaderLine,
  DateRangeDiv,
  RangeText,
} from './styles';
import MISCards from './cards/misCards';
import { UserContext } from '../context/userContext';
import { getIRNSummaryDayWise } from '../../flows/report/metadata';
import {
  IRNSummaryDetails,
  IRNComplianceSummary,
  Range,
  ToastNature,
  ErrorToastText,
} from '../../common/types';
import { getSummary } from '../../flows/report/summary';
import { getPanNumberAndBusiness } from '../../utils/businessDetails';
import { getComplianceSummary } from '../../flows/report/complianceSummary';
import { CALENDAR } from '../../constants/urls';
import { useGlobalState } from '../context/qrState';
import Loading from '../loader/loader';
import { track } from '../../analytics/analytics';
import { EventIDs } from '../../analytics/events';
import NoBusiness from '../noBusiness/noBusiness';
import { getGstinOrgIdAndGstinNameMap } from './utils/gstinOrgIdNameMap';
import Toast from '../Toast';

const MIS = () => {
  const {
    businessHierarchy,
    orgId,
    businessDetails,
    EWB_ENABLED,
    email,
    businessName,
  } = useContext<Record<string, any>>(UserContext);
  const barData = new Map<string, IRNSummaryDetails>();
  const irnMetadata: IRNSummaryDetails = {
    totalPendingIrnGeneration: 0,
    totalNoOfInvoices: 0,
    totalIrnGenerated: 0,
    totalIrnFailed: 0,
    totalIrnCancelled: 0,
  };
  barData.set('branch', irnMetadata);
  const branchOrgName: string = '';
  const gstinOrgName: string = '';
  const gstin: string = '';

  const irn: IRNComplianceSummary = {
    branchOrgName,
    gstinOrgName,
    gstin,
    orgId: undefined,
    irnSummaryDetails: {
      totalIrnCancelled: 0,
      totalIrnFailed: 0,
      totalIrnGenerated: 0,
      totalNoOfInvoices: 0,
      totalPendingIrnGeneration: 0,
    },
  };

  const [misPageData, setMisPageData] = useState({
    barChartData: barData,
    summaryCardData: irnMetadata,
    complianceListData: [irn],
  });

  const [loading, setLoading] = useGlobalState('loadingState');
  const [fetchingStatus, setFetchingStatus] = useGlobalState('dataFetch');
  const [calEnabled, setCalEnabled] = useState(false);
  const [rangeEnabled, setRangeEnabled] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useGlobalState('rangeType');
  const [startValue, setStartValue] = useState(
    localStorage.getItem('START_DATE') ||
      moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')
  );
  const [endValue, setEndValue] = useState(
    localStorage.getItem('END_DATE') ||
      moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
  );

  const handleRangeChange = (e: any) => {
    if (e.target.value === Range.MONTH) {
      setStartValue(
        moment(endValue, 'YYYY-MM-DD HH:mm:ss')
          .subtract(30, 'days')
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      );
      setSelectedDateRange(Range.MONTH);
      localStorage.setItem('RANGE_TYPE', Range.MONTH);
    } else {
      setStartValue(
        moment(endValue, 'YYYY-MM-DD HH:mm:ss')
          .subtract(6, 'days')
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      );
      setSelectedDateRange(Range.WEEK);
      localStorage.setItem('RANGE_TYPE', Range.WEEK);
    }
    setRangeEnabled(false);
    setFetchingStatus('FETCHING_DATA');
    const payload = {
      email,
    };
    if (e.target.value === Range.MONTH) {
      track(EventIDs.MIS_PAGE_LAST30, payload);
    } else {
      track(EventIDs.MIS_PAGE_LAST7, payload);
    }
  };

  const onDateChange = (value: any) => {
    if (
      moment(endValue).endOf('day').format('YYYY-MM-DD HH:mm:ss') !==
      moment(value, 'YYYY-MM-DD').endOf('day').format('YYYY-MM-DD HH:mm:ss')
    ) {
      setEndValue(
        moment(value, 'YYYY-MM-DD').endOf('day').format('YYYY-MM-DD HH:mm:ss')
      );
      if (selectedDateRange) {
        if (selectedDateRange === 'MONTH') {
          setStartValue(
            moment(value, 'YYYY-MM-DD')
              .subtract(30, 'days')
              .startOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          );
        } else {
          setStartValue(
            moment(value, 'YYYY-MM-DD')
              .subtract(6, 'days')
              .startOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          );
        }
      }
      setFetchingStatus('FETCHING_DATA');
    }
    setCalEnabled(false);
  };

  useEffect(() => {
    businessDetails.addPageName('MIS');
    const payload = {
      email,
    };
    track(EventIDs.MIS_PAGE, payload);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (fetchingStatus === 'FETCHING_DATA') {
        setLoading(true);
      } else if (loading) {
        setLoading(false);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchingStatus]);

  useEffect(() => {
    if (businessHierarchy && businessHierarchy.data.length !== 0) {
      let orgIdValue: string =
        localStorage.getItem('ORGID') || businessHierarchy.data[0].id;
      if (orgId) {
        orgIdValue = orgId;
      }
      businessDetails.addBusinessName(
        businessHierarchy.businessDataStore[orgIdValue].name
      );

      const {
        panNumber,
        business,
        panOrgId,
        businessId
      } = getPanNumberAndBusiness(
        businessHierarchy,
        orgIdValue
      );

      const gstinOrgIdGstinOrgNameMap = getGstinOrgIdAndGstinNameMap(
        panOrgId,
        businessHierarchy
      );

      const fetchDataFromApis = async () => {
        let metaDataErrorToast: string = '';
        let summaryErrorToast: string = '';
        let complianceErrorToast: string = '';
        // summary card
        let summaryData: IRNSummaryDetails = irnMetadata;
        try {
          summaryData = await getSummary(
            orgIdValue,
            endValue,
            startValue,
            businessHierarchy.businessDataStore[orgIdValue].level,
            business,
            panNumber,
            businessId,
          );
        } catch (error) {
          summaryErrorToast = ErrorToastText.SUMMARY;
        }

        // bar chart
        let barChartData: Map<string, IRNSummaryDetails> = barData;
        try {
          barChartData = await getIRNSummaryDayWise(
            endValue,
            startValue,
            orgIdValue,
            businessHierarchy.businessDataStore[orgIdValue].level,
            business,
            businessId
          );
        } catch (error) {
          metaDataErrorToast = ErrorToastText.METADATA;
        }

        // Compliance Summary List
        let complianceData: IRNComplianceSummary[] = [irn];
        try {
          complianceData = await getComplianceSummary(
            startValue,
            endValue,
            panOrgId,
            panNumber,
            gstinOrgIdGstinOrgNameMap,
            businessId
          );
        } catch (error) {
          complianceErrorToast = ErrorToastText.COMPLIANCE;
        }

        const misPageDataIRN = {
          barChartData,
          summaryCardData: summaryData,
          complianceListData: complianceData,
        };

        setMisPageData(misPageDataIRN);
        setFetchingStatus('COMPLETED');
        setLoading(false);

        // error toasts
        if (metaDataErrorToast) {
          Toast.notify({
            description: metaDataErrorToast,
            nature: ToastNature.ERROR,
          });
          metaDataErrorToast = '';
        }
        if (summaryErrorToast) {
          Toast.notify({
            description: summaryErrorToast,
            nature: ToastNature.ERROR,
          });
          summaryErrorToast = '';
        }
        if (complianceErrorToast) {
          Toast.notify({
            description: metaDataErrorToast,
            nature: ToastNature.ERROR,
          });
          complianceErrorToast = '';
        }
      };
      fetchDataFromApis();
    } else {
      setFetchingStatus('NO_DATA');
    }
    setRangeEnabled(false);
    localStorage.setItem('START_DATE', startValue);
    localStorage.setItem('END_DATE', endValue);
  }, [
    businessHierarchy,
    orgId,
    startValue,
    endValue,
    selectedDateRange,
    businessDetails,
  ]);

  return (
    <>
      <MisToolBar>
        <MisHeaders color="#454ADE">
          <span>IRN</span>
          <MisHeaderLine color="#454ADE" />
        </MisHeaders>
        {EWB_ENABLED && (
          <MisHeaders color="#6D6D6D">
            <span>
              EWB{' '}
              <span style={{ fontStyle: 'italic', fontSize: '12px' }}>
                (coming soon)
              </span>
            </span>
            <MisHeaderLine color="#ffff" />
          </MisHeaders>
        )}
      </MisToolBar>
      <If condition={loading === true}>
        <Loading text="Loading MIS details" index={0} />
      </If>
      <If condition={loading === false}>
        <If condition={businessName !== 'No businesses added'}>
          <Mis>
            <DateRangeDiv>
              {calEnabled && (
                <DatePicker
                  open={calEnabled}
                  placeholder={moment(startValue, 'YYYY-MM-DD HH:mm:ss').format(
                    'DD-MM-YYYY'
                  )}
                  onChange={onDateChange}
                />
              )}
              {!calEnabled && startValue && (
                <DateRange
                  aria-hidden="true"
                  onClick={() => {
                    setCalEnabled(true);
                    const payload = {
                      email,
                    };
                    track(EventIDs.MIS_PAGE_CALENDAR, payload);
                  }}
                  onKeyDown={() => setCalEnabled(true)}
                >
                  <img src={CALENDAR} alt="" width="24px" height="24px" />
                  <If condition={selectedDateRange === 'MONTH'}>
                    <RangeText>This Month,&nbsp;</RangeText>
                    {moment(startValue).format('Do MMM')} -{' '}
                    {moment(endValue).format('Do MMM')}
                  </If>
                  <If condition={selectedDateRange !== 'MONTH'}>
                    <RangeText>This Week,&nbsp;</RangeText>{' '}
                    {moment(startValue).format('Do MMM')} -{' '}
                    {moment(endValue).format('Do MMM')}
                  </If>
                </DateRange>
              )}
              <DateRangeText>
                {rangeEnabled && (
                  <select
                    style={{
                      fontFamily: 'Nunito',
                      fontSize: '12px',
                      width: '91px',
                      marginLeft: '5px',
                      marginBottom: '5px',
                    }}
                    onChange={handleRangeChange}
                    value={
                      selectedDateRange === 'TODAY' ||
                      selectedDateRange === 'WEEK'
                        ? 'WEEK'
                        : 'MONTH'
                    }
                  >
                    <option value="WEEK">last 7 days</option>
                    <option value="MONTH">last 30 days</option>
                  </select>
                )}
                {!rangeEnabled && (
                  <span
                    onClick={() => {
                      setRangeEnabled(true);
                      const payload = {
                        email,
                      };
                      track(EventIDs.MIS_PAGE_EDIT_DURATION, payload);
                    }}
                  >
                    Edit Duration
                  </span>
                )}
              </DateRangeText>
            </DateRangeDiv>
            <MisBarChart>
              <Barchart
                barData={misPageData.barChartData}
                fromDate={startValue}
                toDate={endValue}
                range={selectedDateRange}
              />
            </MisBarChart>
            <MISSummaryCard summaryCardData={misPageData.summaryCardData} />
            <MISCards cardsData={misPageData.complianceListData} />
          </Mis>
        </If>
        <If condition={businessName === 'No businesses added'}>
          <NoBusiness />
        </If>
      </If>
    </>
  );
};

export default MIS;
